export const WIKI_PERMISSIONS = [
  { key: 'MANAGE_PAGES', label: 'Статьи' },
  { key: 'MANAGE_CATEGORIES', label: 'Разделы' },
  { key: 'MANAGE_IMAGES', label: 'Изображения' },
  { key: 'MANAGE_MAP', label: 'Карта' },
  { key: 'MANAGE_TOURNAMENTS', label: 'Турниры' },
  { key: 'VIEW_ANALYTICS', label: 'Аналитика' },
  { key: 'MANAGE_USERS', label: 'Пользователи' },
];
